<!--
  File name: SelfAssessmentForm.vue
  Program Description:
    - This modal component is used for PIC self assesment form
    - It contains all the necessary fields and validations
-->
<template>
  <v-container>
    <v-dialog
      v-model="showDialog"
      max-width="780"
    >
      <v-card
        v-if="showDialog"
        class="pa-6"
        tile
      >
        <v-card-title
          class="headline primary--text"
        >
          Self Assessment Form
        </v-card-title>
        <div
          v-for="(object, index) in questionArray"
          :key="object.id"
        >
          <v-card-text>
            {{ object.question }}
          </v-card-text>
          <div
            v-if="object.yesNo"
          >
            <v-select
              v-model="object.answer"
              label="Answer"
              outlined
              class="yes-no--mod"
              :items="['Yes', 'No']"
              :error-messages="genericErrorObjectArray('questionArray', index, 'answer', 'Answer')"
              @input="$v.questionArray.$each[index].answer.$touch()"
              @blur="$v.questionArray.$each[index].answer.$touch()"
            />
          </div>
          <div
            v-else
          >
            <v-select
              :items="object.items"
            />
          </div>
        </div>
        <v-card-actions
          class="justify-end"
        >
          <v-btn
            class="primary--text font-weight-bold button--border ma-3"
            large
            text
            @click="$store.dispatch('showDialog', {
              title: 'Discard Self Assessment',
              message: 'Are you sure you want to discard your Self Assessment Form?',
              buttonLabel: 'Yes',
              buttonColor: 'error',
              callback: () => showDialog = false
            })"
          >
            Cancel
          </v-btn>
          <v-btn
            class="primary button--border ma-3"
            width="20%"
            large
            @click="submit"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="submitDialog"
      width="unset"
      persistent
    >
      <v-card
        max-width="370"
        class="pa-10"
      >
        <v-btn
          style="position:absolute; top:10px; right:10px;"
          icon
          @click="submitDialog = false"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
        <v-container
          class="d-flex justify-center align-center"
        >
          <v-img
            class="ma-5 justify-center align-center"
            max-height="300"
            max-width="250"
            :src="$metaData.app.selfAssessmentImage"
          />
        </v-container>
        <v-card-title class="justify-center py-0 primary--text font-weight-bold">
          Self Assessment Result
        </v-card-title>
        <v-card-text class="text-center black--darken-1 font-weight-bold">
          You are <span :class="isMandatory ? 'amber--text' : 'danger--text'">{{ selfAssessmentResultMessage }} mandatory data breach</span> notification report.
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import { validationMixin, validationErrors } from '@/utils/validations'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'SurveyForm',
  mixins: [
    validationMixin
  ],
  props: {
    value: Boolean
  },
  data: () => ({
    submitDialog: false,
    isMandatory: false,
    selfAssessmentResultMessage: '',
    questionArray: [
      {
        id: 1,
        question: '1. Did the breach involve personal information?',
        yesNo: true
      },
      {
        id: 2,
        question: '2. Does it involve Sensitive Personal Information or any information that may enable identity fraud?',
        yesNo: true
      },
      {
        id: 3,
        question: '3. Was it acquired by an unauthorized person?',
        yesNo: true
      },
      {
        id: 4,
        question: '4. Is it likely to give rise to real risk of serious harm to data subjects?',
        yesNo: true
      },
      {
        id: 5,
        question: '5. Is the number of affected data subjects 100 or more?',
        yesNo: true
      }
    ]
  }),
  computed: {
    ...validationErrors,
    showDialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    resetAnswers () {
      for (const object of this.questionArray) {
        object.answer = ''
      }
    },
    close () {
      this.resetAnswers()
      this.showDialog = false
    },
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return this.$store.dispatch('showAlert', {
          message: 'Cannot submit form with incomplete info.',
          type: 'error'
        })
      }

      let yes = 0
      for (const object of this.questionArray) {
        if ([2, 3, 4].includes(object.id) && object.answer === 'Yes') {
          yes += 1
        }
      }

      if (yes < 3) {
        this.selfAssessmentResultMessage = 'not for'
        this.isMandatory = false
      } else {
        this.selfAssessmentResultMessage = 'for'
        this.isMandatory = true
      }

      this.submitDialog = true
      this.showDialog = false
      this.resetAnswers()
      this.$v.$reset()
    }
  },
  validations () {
    return {
      questionArray: {
        $each: {
          answer: {
            required
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .yes-no--mod {
    width: 15%;
    margin-left: 5%;
  }

  .button--border {
    border-radius: 8px;
  }
</style>
